import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { ICarnetsMealsStatisticsResponse } from "../domain/ICarnetsMealsStatisticsResponse";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface CarnetsMealsStatisticsState {
  loading: boolean;
  statistics?: ICarnetsMealsStatisticsResponse;
  error: any;
}

const initialState: CarnetsMealsStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getCarnetsMealsStatistics = createAsyncThunk(
  "Statistics/getCarnetsMealsStatistics",
  async (year?: IYearRequestParams) => {
    try {
      const result = await StatisticsService.getCarnetsMealsStatistics(year);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const CarnetsMealsStatisticsSlice = createSlice({
  name: "CarnetsMealsStatistics",
  initialState: initialState,
  reducers: {
    setStatistics: (
      state,
      action: PayloadAction<ICarnetsMealsStatisticsResponse>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCarnetsMealsStatistics.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(getCarnetsMealsStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload ? action.payload : undefined;
      });
      builder.addCase(getCarnetsMealsStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  }
});

export const selectState = (state: RootState) => state.statistics.carnetsmeals;

export const { setError } = CarnetsMealsStatisticsSlice.actions;

export default CarnetsMealsStatisticsSlice.reducer;


